var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.712 16.4l-2.266 2.266q-.14.14-.334.13q-.195-.01-.335-.15t-.14-.347t.14-.341l2.246-2.246l-2.265-2.266q-.14-.14-.131-.344t.15-.344t.347-.14t.341.14l2.247 2.265l2.265-2.265q.134-.14.341-.14t.348.14t.14.347t-.14.341L17.4 15.712l2.266 2.265q.14.14.14.335t-.14.334t-.348.14t-.341-.14zm-.631-7.129l3.896-3.896q.146-.146.354-.153t.354.159q.14.153.14.357t-.14.35l-4.014 4.02q-.242.242-.565.242t-.566-.242l-1.938-1.939q-.14-.14-.13-.344q.009-.204.15-.344t.347-.14t.34.14zM3.5 15.116h7q.213 0 .356.143q.144.144.144.357t-.144.356t-.356.144h-7q-.213 0-.356-.144T3 15.615t.144-.356t.356-.143m0-7.231h7q.213 0 .356.144t.144.356t-.144.356t-.356.143h-7q-.213 0-.356-.143Q3 8.597 3 8.384t.144-.356t.356-.144"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction);
export default __webpack_public_path__ + "static/media/instruction.3f18296eceb5114627428aea84092f09.svg";
export { ForwardRef as ReactComponent };